const destinationProjection = 'EPSG:3857';

export enum Projection {
  PSEUDO_MERCATOR = 'pseudo_mercator',
  AZIMUTHAL_EQUIDISTANT = 'azimuthal_equidistant',
  POLAR_STEREOGRAPHIC = 'polar_stereographic',
}
const availableProjections = [
  {
    title: 'Azimuthal Equidistant',
    name: Projection.AZIMUTHAL_EQUIDISTANT,
    epsg: 'ESRI:54032',
    config: '+proj=aeqd +lat_0=32.6938 +lon_0=-16.7753 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs',
    extent: [-20037508.34, -20037508.34, 20037508.34, 20037508.34],
  },
  {
    title: 'Pseudo-Mercator',
    name: Projection.PSEUDO_MERCATOR,
    epsg: 'EPSG:3857',
    config: '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs',
    extent: [-20037508.34, -20037508.34, 20037508.34, 20037508.34],
  },
  {
    title: 'Polar Stereographic',
    name: Projection.POLAR_STEREOGRAPHIC,
    epsg: 'EPSG:42301',
    config: '+proj=stere +lat_0=90 +lon_0=-98 +k=1 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs',
    extent: [-20037508.34, -20037508.34, 20037508.34, 20037508.34],
  },
];

export { destinationProjection, availableProjections };
